import React from 'react';
import { detectMobile } from '../../../utils/UiHelper';
import {
    SkeletonContainer,
    SkeletonList,
    SkeletonCard,
    SkeletonLine,
    SkeletonDot,
} from '../styled';

const HorizontalNavigationSkeleton = () => {
    const isMobile = detectMobile();
    const itemCount = isMobile ? 12 : 22;

    const renderSkeletonMenu = () =>
        Array.from({ length: itemCount }, (_, index) => (
            <SkeletonCard
                key={`menu_item_${index}`}
                width={isMobile ? '64px' : '64px'}
                padding={isMobile ? '12px 12px 10px' : '12px 12px 20px'}
                radius={'8px'}
            >
                <SkeletonDot
                    size={'40px'}
                    margin={isMobile ? '0 0 14px' : '0 0 8px'}
                />
                <SkeletonLine
                    height={'8px'}
                    width={'32px'}
                    margin={'0 auto'}
                    radius={'4px'}
                />
            </SkeletonCard>
        ));

    return (
        <SkeletonContainer
            margin={isMobile ? '0 0 20px' : '0 0 28px'}
            padding={isMobile ? '8px 16px' : '8px 0'}
            isMobile={isMobile}
        >
            <SkeletonList gap={'16px'}>{renderSkeletonMenu()}</SkeletonList>
        </SkeletonContainer>
    );
};

export default HorizontalNavigationSkeleton;
